import { Typography } from "@mui/material"
import { If, Else } from "lib/@components/switch"
import { convertToNumberIfPossible } from "lib/number"
import { getCurrencySymbol } from "./currency-symbol"
import { EmptyValue, isEmptyValue } from "./requested-field-value-empty"

/**
 * Read-only display of a `currency` requested field's answer: the field's currency symbol (from
 * `field.currencyCode`) followed by the locale-formatted amount. `0` is a valid amount, so emptiness is
 * decided by `isEmptyValue`. Counterpart of `currency-field-input.js`, sharing its `getCurrencySymbol`.
 *
 * @param {object} props
 * @param {{ id: string, currencyCode?: string }} props.field
 * @param {number|string} [props.value]
 */
export function CurrencyFieldValue({ field, value }) {
    return (
        <If value={!isEmptyValue(value)}>
            <Typography variant="body2">
                {getCurrencySymbol(field.currencyCode)}
                {formatAmount()}
            </Typography>
            <Else>
                <EmptyValue />
            </Else>
        </If>
    )

    function formatAmount() {
        const numeric = convertToNumberIfPossible(value)
        return typeof numeric === "number" && !Number.isNaN(numeric) ? numeric.toLocaleString() : value
    }
}
